export default __webpack_public_path__ + "static/PPNeueMontreal-SemiBold-82363d624b471941cd6b3f2e06777e06.woff2";